import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import UITextInput from 'Components/UIComponents/UITextInput';

import { FieldInput } from '..';

const FieldTextInput = (props: FieldRenderProps<string>) => (
  <FieldInput {...props} renderInput={props => <UITextInput {...props} />} />
);

export default FieldTextInput;
